import React, { FC, useEffect } from 'react';
import Routes from 'routes/routes';
import 'styles/fonts.css';
import GlobalStyles from 'styles/global';
import TagManager from 'react-gtm-module';
import { AlertModalProvider } from 'modals/alert-modal/alert-modal-provider';
import { CampanhaProvider } from 'context/campanha-context';
import { AutoApprovalProvider } from 'hooks/useAutoApproval';
import { LoginProvider } from 'context/login-context';
import { MobileRestriction } from '@fundacao/shared-components/esm/ie';

const App: FC = () => {
  useEffect(() => {
    setTimeout(() => {
      TagManager.initialize({ gtmId: 'GTM-T7XBG7S' });
    }, 6000);
  }, []);

  return (
    <MobileRestriction>
      <LoginProvider>
        <GlobalStyles />
        <AlertModalProvider>
          <AutoApprovalProvider>
            <CampanhaProvider>
              <Routes />
            </CampanhaProvider>
          </AutoApprovalProvider>
        </AlertModalProvider>
      </LoginProvider>
    </MobileRestriction>
  );
};

export default App;
